import React from 'react'

const Header = function header (){
    return (
        <nav className="header">
            <div className="nav-wrapper">
                <a href="#" className="brand-logo">Films H&D</a>
                <ul id="nav-mobile" className="right hide-on-med-and-down">
                    <li><a href={https}>Lista</a></li>
                    <li><a href={https+"random"}>Generar uno al azar</a></li>
                    <li><a href={https+"logout"}>Cerrar Sesion</a></li>
                </ul>
            </div>
        </nav>
    )
}

export default Header
